import { render, staticRenderFns } from "./FileSystemLogs.vue?vue&type=template&id=64b1b85a"
import script from "./FileSystemLogs.vue?vue&type=script&lang=js"
export * from "./FileSystemLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports